import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../lib/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function Signup() {
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const [form, setForm] = useState({
    email: "", password: "", name: "", restaurant_name: "",
    phone: "", company_name: "", vat_number: "", company_address: "",
  });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/signup", form);
      loginWithToken(data.token, data.user);
      toast.success("Account creato! Scegli il tuo piano");
      navigate("/choose-plan");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Errore registrazione");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FBF9F5] flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 mb-8">
          <div className="w-9 h-9 rounded-2xl bg-gradient-to-br from-[#D99B26] to-[#C85A32] grid place-items-center text-white font-black">V</div>
          <span className="font-heading text-lg font-black tracking-tight">VOICE<span className="bg-gradient-to-r from-[#D99B26] to-[#C85A32] text-transparent bg-clip-text">MENU</span></span>
        </Link>
        <h1 className="font-serif-display text-4xl font-bold">Crea il tuo menu vocale</h1>
        <p className="text-[#6B625B] mt-2">Compila i dati del tuo locale per iniziare.</p>

        <form onSubmit={submit} className="mt-8 space-y-6">
          <fieldset className="space-y-4">
            <legend className="text-[10px] uppercase tracking-widest font-black text-[#C85A32]">Dati account</legend>
            <div>
              <Label>Nome e cognome</Label>
              <Input data-testid="signup-name-input" required value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} placeholder="Mario Rossi" />
            </div>
            <div>
              <Label>Email</Label>
              <Input data-testid="signup-email-input" type="email" required value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} placeholder="mario@osteriadelsole.it" />
            </div>
            <div>
              <Label>Telefono</Label>
              <Input data-testid="signup-phone-input" type="tel" inputMode="tel" required value={form.phone} onChange={(e) => setForm({...form, phone: e.target.value})} placeholder="+39 333 1234567" />
            </div>
            <div>
              <Label>Password</Label>
              <Input data-testid="signup-password-input" type="password" required minLength={6} value={form.password} onChange={(e) => setForm({...form, password: e.target.value})} placeholder="Almeno 6 caratteri" />
            </div>
          </fieldset>

          <fieldset className="space-y-4 pt-2 border-t border-[#E8E2D5]">
            <legend className="text-[10px] uppercase tracking-widest font-black text-[#C85A32] pt-4">Dati locale · Fatturazione</legend>
            <div>
              <Label>Nome del ristorante (pubblico)</Label>
              <Input data-testid="signup-restaurant-input" required value={form.restaurant_name} onChange={(e) => setForm({...form, restaurant_name: e.target.value})} placeholder="Osteria del Sole" />
            </div>
            <div>
              <Label>Ragione sociale</Label>
              <Input data-testid="signup-company-input" required value={form.company_name} onChange={(e) => setForm({...form, company_name: e.target.value})} placeholder="Osteria del Sole S.r.l." />
            </div>
            <div>
              <Label>Partita IVA / Codice Fiscale</Label>
              <Input data-testid="signup-vat-input" required value={form.vat_number} onChange={(e) => setForm({...form, vat_number: e.target.value})} placeholder="IT01234567890" />
            </div>
            <div>
              <Label>Indirizzo sede legale</Label>
              <Input data-testid="signup-address-input" required value={form.company_address} onChange={(e) => setForm({...form, company_address: e.target.value})} placeholder="Via Roma 12, 20100 Milano" />
            </div>
          </fieldset>

          <Button data-testid="signup-submit-btn" disabled={loading} className="w-full bg-[#C85A32] hover:bg-[#B24E2A] text-white rounded-full py-6">
            {loading ? "Creazione..." : "Crea Account"}
          </Button>
        </form>

        <p className="mt-3 text-sm text-[#6B625B] text-center">
          Hai già un account? <Link to="/login" className="text-[#C85A32] font-semibold hover:underline">Accedi</Link>
        </p>
      </div>
    </div>
  );
}
